import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/office/office-hero-bg-new.jpg")